import BaseComponent from "../../../baseComponent.js";
import DataSetWithFields from "./datasetWithFields.jsx";
import DataSetWithoutFields from "./datasetWithoutFields.jsx";
import Function from "./function.jsx";
import WidgetType from "../../../../core/constants/widgetType.js";
import styles from "./styles.scss";

export default class DatasetWithFields extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleScroll(e) {
    if (this.props.typeIndex === 2) return;
    var target = e.target;
    if ($(target).scrollTop() + $(target).innerHeight() + 10 >= $(target)[0].scrollHeight) {
      this.props.nextPage(this.props.typeIndex);
    }
  }

  render() {
    var listItem = [];
    if (this.props.typeIndex === 2) {
      for (var i = 0; i < this.props.functions.length; i++) {
        listItem.push(<Function function={this.props.functions[i]} key={i}/>);
      }
    } else {
      for (var i = 0; i < this.props.datasets.length; i++) {
        if (this.props.widgetType === WidgetType.TABLE) {
          listItem.push(<DataSetWithoutFields dataset={this.props.datasets[i]} key={i}/>);
        } else {
          listItem.push(<DataSetWithFields dataset={this.props.datasets[i]} key={i}/>);
        }
      }
    }

    return (
      <div className={styles.pageableList} onScroll={this.handleScroll}>
        <ul>
          {listItem}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/search/pageableList.jsx